module.exports = __webpack_public_path__ + "img/user.61b5e878.png";